import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import JobCard from '../components/Jobs/JobCard';
import { useJobDetByIdQuery, useJobAllQuery } from '../store/api/userApiSlice';
import { IoArrowBack } from 'react-icons/io5';
import './JobDetailsPage.css';

const JobDetailsPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    // Fetch Job Details
    const { data: jobData, isLoading: isJobLoading, error: jobError } = useJobDetByIdQuery(id);
    // The API might return { data: { ...job } } or just { ...job } or [ ...job ]. 
    // userApiSlice says `/getjobby/${jobId}`. Assuming standard wrapper.
    const job = jobData?.data || jobData;

    // Fetch Similar Jobs (Fetching all for now and slicing)
    const { data: allJobsData } = useJobAllQuery();
    const allJobs = allJobsData?.data || (Array.isArray(allJobsData) ? allJobsData : []) || [];
    
    // Simple similarity: exclude current job
    const similarJobs = allJobs
        .filter(j => (j._id || j.id) !== id)
        .slice(0, 8); // Show 8 similar jobs

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [id]);

    const handleJobClick = (jobId) => {
        navigate(`/jobs/${jobId}`);
    };

    if (isJobLoading) {
        return (
            <div className="page-wrapper">
                <Navbar />
                <div style={{ padding: '80px', textAlign: 'center' }}>Loading Job Details...</div>
                <Footer />
            </div>
        );
    }

    if (!job || jobError) {
        return (
            <div className="page-wrapper">
                <Navbar />
                <div style={{ padding: '80px', textAlign: 'center' }}>
                    <h2>Job Not Found</h2>
                    <p>The job listing you are looking for might have been removed or expired.</p>
                </div>
                <Footer />
            </div>
        );
    }

    return (
        <div className="page-wrapper">
            <Navbar />
            
            <div className="job-details-page">
                {/* Back Button */}
                 <button className="back-btn" onClick={() => navigate(-1)} style={{marginBottom: '12px', display:'flex', alignItems:'center', gap:'8px', background:'none', border:'none', cursor:'pointer', fontSize:'16px', color:'#333'}}>
                    <IoArrowBack size={20} /> Back
                </button>

                <div className="job-details-container">
                    {/* Left Column: Job Details */}
                    <div className="job-details-content">
                        {/* 1. Job Card directly (no tags, with apply button) */}
                        <JobCard 
                            job={job} 
                            onClick={() => {}} 
                            hideTags={true} 
                            showApplyButton={true}
                        />

                        {/* 2. Description Box */}
                        <div className="job-full-description-box">
                            <h3 className="description-title">Job Description</h3>
                            <div className="description-text">
                                {job.description || "No description available."}
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Similar Jobs */}
                    <div className="job-details-sidebar">
                        <div className="similar-jobs-card-container">
                            <h3 className="similar-jobs-title">Similar jobs</h3>
                            <div className="similar-jobs-list">
                                {similarJobs.map(simJob => (
                                    <JobCard 
                                        key={simJob._id || simJob.id} 
                                        job={simJob} 
                                        onClick={() => handleJobClick(simJob._id || simJob.id)} 
                                        minimal={true}
                                        hideTags={false} // "right side we have similar jobs card which are exact same as our job card" implies tags shown
                                    />
                                ))}
                                {similarJobs.length === 0 && <p style={{padding: '20px', textAlign: 'center'}}>No similar jobs found.</p>}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default JobDetailsPage;
